var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseRoundedBorders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "2p8be6jyya"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D6870",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90A0AB",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1.92C6.442 1.92 1.92 6.442 1.92 12S6.442 22.08 12 22.08 22.08 17.558 22.08 12 17.558 1.92 12 1.92zM9.77 6.14a1.2 1.2 0 0 1 1.2 1.2v9.12a1.2 1.2 0 1 1-2.4 0V7.34a1.2 1.2 0 0 1 1.2-1.2zm4.8 0a1.2 1.2 0 0 1 1.2 1.2v9.12a1.2 1.2 0 1 1-2.4 0V7.34a1.2 1.2 0 0 1 1.2-1.2z",
    fill: "url(#2p8be6jyya)",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseRoundedBorders);
export default __webpack_public_path__ + "static/media/pause-rounded-borders.f9980d8ec4e35d6202d28915f68a8cac.svg";
export { ForwardRef as ReactComponent };